import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import IPBoardPart from 'src/app/model/product/ip-board/ip-board-part';
import { IPBoardPartAbbreviation } from 'src/app/model/product/ip-board/ip-board-part-abbreviation';
import {
  AbbrevationSelectState,
  IPBoardPartAbbreviationSelectorHelper,
} from './ip-board-part-abbreviation-selector-helper';

@Component({
  selector: 'ip-board-part-abbreviation-selector',
  templateUrl: './ip-board-part-abbreviation-selector.component.html',
  styleUrls: ['./ip-board-part-abbreviation-selector.component.scss'],
})
export class IPBoardPartAbbreviationSelectorComponent implements OnInit {
  @Input()
  ipBoardPart: IPBoardPart;

  @Output()
  selectionChanged = new EventEmitter<IPBoardPartAbbreviation[]>();

  intendSelectAny: boolean;

  abbreviationSelectStates: AbbrevationSelectState[];

  ngOnInit(): void {
    this.abbreviationSelectStates =
      IPBoardPartAbbreviationSelectorHelper.initializeAbbreviationSelectStates(
        this.ipBoardPart.abbreviations
      );
    this.intendSelectAny = this.abbreviationSelectStates.some(
      (s) => s.selected
    );
  }

  saveSelection(): void {
    if (!this.intendSelectAny) {
      this.selectionChanged.emit([]);
      return;
    }
    const toEmit = this.abbreviationSelectStates
      .filter((s) => s.selected)
      .map((s) => {
        if (s.existingIPBoardPartAbbreviation != null) {
          return s.existingIPBoardPartAbbreviation;
        }
        const toReturn = new IPBoardPartAbbreviation();
        toReturn.abbreviation = s.abbreviation;
        return toReturn;
      });
    this.selectionChanged.emit(toEmit);
  }

  close(): void {
    this.selectionChanged.emit(null);
  }
}
